
import React from 'react';

interface LogoProps {
  className?: string;
  size?: number;
  showText?: boolean;
  inverted?: boolean;
}

const Logo: React.FC<LogoProps> = ({ className = "", size = 40, showText = false, inverted = false }) => {
  const primaryColor = inverted ? "#FFFFFF" : "#E11D48";
  const secondaryColor = inverted ? "rgba(255,255,255,0.8)" : "#1E3A8A";
  const textColor = inverted ? "#FFFFFF" : "#1F2937";

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg 
        width={size} 
        height={size} 
        viewBox="0 0 100 100" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="drop-shadow-sm"
      >
        {/* Shield Background */}
        <path 
          d="M50 5L15 20V45C15 65.5 30 84.5 50 95C70 84.5 85 65.5 85 45V20L50 5Z" 
          fill={primaryColor} 
        />
        
        {/* Stylized 'T' / Lighthouse / Mountain inside shield */}
        <path 
          d="M50 25V75M35 35H65" 
          stroke="white" 
          strokeWidth="8" 
          strokeLinecap="round" 
        />
        
        {/* Mountain Peak detail */}
        <path 
          d="M50 25L30 55H70L50 25Z" 
          fill="white" 
          fillOpacity="0.2"
        />

        {/* Waves at the bottom */}
        <path 
          d="M25 65C30 62 35 68 40 65C45 62 50 68 55 65C60 62 65 68 70 65" 
          stroke="white" 
          strokeWidth="4" 
          strokeLinecap="round" 
        />
        <path 
          d="M28 75C33 72 38 78 43 75C48 72 53 78 58 75C63 72 68 78 73 75" 
          stroke="white" 
          strokeWidth="4" 
          strokeOpacity="0.6" 
          strokeLinecap="round" 
        />
      </svg>
      
      {showText && (
        <div className="flex flex-col">
          <span className="font-black tracking-tighter leading-none text-lg" style={{ color: textColor }}>
            Siaga<span style={{ color: primaryColor }}>Tegal</span>
          </span>
          <span className="text-[8px] font-black uppercase tracking-[0.2em] opacity-70" style={{ color: textColor }}>
            Laka-Laka
          </span>
        </div>
      )}
    </div>
  );
};

export default Logo;
